import { defineAsyncComponent } from 'vue';

export const LazyFormSchemaFields = defineAsyncComponent(() => import('./components/FormSchema/FormSchemaFields.vue'));
